import { Component } from '@angular/core';

import { Platform, NavController, Events } from '@ionic/angular';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';

import { TranslateProvider } from './providers/translate/translate.service';
import { TranslateService } from '@ngx-translate/core';
import { environment } from '../environments/environment';

import { Pages } from './interfaces/pages';
import { AppVersion } from '@ionic-native/app-version/ngx';

import { Storage } from '@ionic/storage';
import { SessionService } from './providers/session/session.service';
import { SessionData } from './interfaces/session-data';
import { Member } from './interfaces/member';
import { Contract } from './interfaces/contract';
import { APP_PAGES } from './config/menu';
import { MemberService } from './providers';
import { Observable } from 'rxjs';
import { NavigationCancel, NavigationEnd, NavigationError, NavigationStart, Router } from '@angular/router';
import { LoaderService } from './providers/loader/loader.service';
/**
 * Main Wrap App Component with starting methods
 *
 * @export
 * @class AppComponent
 */
@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['./app.component.scss']
})

export class AppComponent {

  // Información del Socio
  public member: Member = {
    Id: null,
    Number: null,
    ContractStateName: null,
    ContractCanBeUsed: false,
    ContractCanBeUsedForHotel: false,
    ClientId: null,
    ClientName: null,
    ClientDocument: null,
    ClientEmail: null,
    DateOfSale: null,
    DateProcessed: null
  };

  // Información del Contrato
  public contract: Contract;

  // Si es el socio Principal
  public isPrimary: boolean;

  // Si el Socio puede utilizar los servicios del Club
  public canBeUsed: boolean;

  // Fecha de la ultima sincronización
  public syncDate: number;

  /**
   * Creates an Array instance with <Pages> interface that receives all menu list.
   *
   * @type {Array<Pages>}
   * @memberof AppComponent
   */
  public appPages: Array<Pages>;
  /**
   * Creates an instance of AppComponent.
   * @param {Platform} platform
   * @param {SplashScreen} splashScreen
   * @param {StatusBar} statusBar
   * @param {TranslateProvider} translate
   * @param {TranslateService} translateService
   * @param {NavController} navCtrl
   * @memberof AppComponent
   */
  constructor(
    private platform: Platform,
    private splashScreen: SplashScreen,
    private statusBar: StatusBar,
    private translate: TranslateProvider,
    private translateService: TranslateService,
    public navCtrl: NavController,
    private storage: Storage,
    public events: Events,

    public session: SessionService,
    private memberService: MemberService,
    private appVersion: AppVersion,
    private loaderService: LoaderService,
    private router: Router
  ) {

    this.appPages = APP_PAGES;

    this.events.subscribe('user:login', () => {
      this.updateSession();
    });

    this.events.subscribe('user:logout', () => {
      this.removeSession();
    });

    this.initializeApp();

    this.checkAppVersion();

    this.checkIfUsersIsRegistered();
  }
  /**
   * Method that starts all Cordova and Factories
   *
   * @memberof AppComponent
   */
  initializeApp() {
    this.platform.ready().then(() => {
      this.statusBar.styleDefault();
      setTimeout(() => {
        this.splashScreen.hide();
      }, 1000);
      // Set language of the app.
      this.translateService.setDefaultLang('es');
      const lang = this.translateService.getBrowserLang();
      this.translateService.use(lang);
      this.translateService.getTranslation(lang).subscribe(translations => {
        this.translate.setTranslations(translations);
      });
    }).catch(() => {
      // Set language of the app.
      this.translateService.setDefaultLang(environment.language);
      this.translateService.use(environment.language);
      this.translateService.getTranslation(environment.language).subscribe(translations => {
        this.translate.setTranslations(translations);
      });
    });
  }

  /**
   * Navigate to Edit Profile Page
   *
   * @memberof AppComponent
   */
  goToEditProfile() {
    this.navCtrl.navigateForward('edit-profile');
  }
  /**
   * Logout Method
   *
   * @memberof AppComponent
   */
  logout() {
    this.removeSession();
    this.navCtrl.navigateRoot('register');
  }

  checkAppVersion() {
    let an = this.appVersion.getAppName();
    let pn = this.appVersion.getPackageName();
    let vc = this.appVersion.getVersionCode();
    let vn = this.appVersion.getVersionNumber();
    console.log(an + ' - ' + pn + ' - ' + vc + ' - ' + vn);
  }

  checkIfUsersIsRegistered() {
    this.session.getValue('syncdate').then((syncdate) => {
      // Existe una fecha de actualización
      if (syncdate !== null) {
        const diff = Math.abs(new Date(syncdate).getTime() - Date.now());
        const diffDays = Math.ceil(diff / (1000 * 3600 * 24));
        if (diffDays > 30) {
          // Datos muy antiguos
          this.removeSession();
          this.navCtrl.navigateRoot('register');
        } else if (diffDays > 7) {
          // Refrescar datos
          this.updateSession();
          this.session.getAll().then((storage) => {
            this.memberService.updateMember(storage.member.Number, storage.member.ClientDocument, storage.member.ClientEmail);
          }
          );
          this.updateSession();
          this.navCtrl.navigateRoot('posts-list');
        } else {
          // Uso normal
          this.updateSession();
          this.navCtrl.navigateRoot('posts-list');
        }
      } else {
        this.navCtrl.navigateRoot('register');
      }
    }).catch(error => {
      this.navCtrl.navigateForward('register');
    });
  }

  private async updateSession() {
    const response = await this.session.load();
    this.member = response.member;
    this.contract = response.contract;
    this.isPrimary = response.primary;
    this.canBeUsed = response.canbeused;
  }

  private removeSession() {
    this.member = null;
    this.contract = null;
    this.isPrimary = null;
    this.canBeUsed = false;
    this.session.destroySession();
  }

  ngOnInit() {

    
  }

}
